import { TabsOverrides } from "baseui/tabs-motion";
import theme from "@styles/theme";

export const tabsOverrides: TabsOverrides = {
  TabBorder: {
    style: {
      width: "252px",
    },
  },
  TabHighlight: {
    style: {
      backgroundColor: theme.colors.buttonPrimaryFill,
    },
  },
};

export const tabOverrides = {
  Tab: {
    style: ({ $isActive }: { $isActive: boolean }) => ({
      fontWeight: $isActive ? 600 : 400,
    }),
  },
};
